// extracted by mini-css-extract-plugin
module.exports = {"topBar":"DashboardPage_topBar__1HGtH","buttons":"DashboardPage_buttons__ErXe_","addGame":"DashboardPage_addGame__314Pn","gameContainer":"DashboardPage_gameContainer__1XA_F"};